var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-assistant-agent" },
    [
      _c("div", { staticClass: "ai-assistant-agent__title" }, [
        _vm._v("添加智能体"),
      ]),
      _c(
        "a",
        {
          staticClass: "ai-assistant-agent__close",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.handleAgentClose.apply(null, arguments)
            },
          },
        },
        [_c("a-icon", { attrs: { type: "close" } })],
        1
      ),
      _c(
        "a-space",
        { staticStyle: { width: "100%" }, attrs: { direction: "vertical" } },
        _vm._l(_vm.agents, function (agent, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "ai-assistant-agent-card",
              on: {
                click: function ($event) {
                  return _vm.onClick(agent)
                },
              },
            },
            [
              _c("div", { staticClass: "ai-assistant-agent__title" }, [
                _vm._v(_vm._s(agent.agent_name)),
              ]),
              _c("div", { staticClass: "ai-assistant-agent__desc" }, [
                _vm._v(_vm._s(agent.agent_desc)),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }